import { apiClient } from './api';
import type { UserPreferencesPublic, AppConfigResponse } from '@wooconnect/shared';

export async function getPreferences(): Promise<UserPreferencesPublic> {
  const res = await apiClient.get('/settings/preferences');
  return res.data.data;
}

export async function updatePreferences(data: Partial<UserPreferencesPublic>): Promise<UserPreferencesPublic> {
  const res = await apiClient.put('/settings/preferences', data);
  return res.data.data;
}

export async function getProfile(): Promise<{ id: string; email: string; firstName: string; lastName: string; avatarUrl: string | null; phone: string | null; company: string | null }> {
  const res = await apiClient.get('/settings/profile');
  return res.data.data;
}

export async function updateProfile(data: { firstName?: string; lastName?: string; avatarUrl?: string; phone?: string; company?: string }): Promise<unknown> {
  const res = await apiClient.put('/settings/profile', data);
  return res.data.data;
}

export async function changePassword(data: { currentPassword: string; newPassword: string }): Promise<void> {
  await apiClient.put('/auth/change-password', data);
}

export async function getAppConfig(): Promise<AppConfigResponse> {
  const res = await apiClient.get('/settings/app-config');
  return res.data.data;
}
